import { useFormContext } from 'react-hook-form';
import { FfcChildProps, getFieldErrors } from '../shared';
import { FormEditorForm } from '../../../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import RequiredSwitch from './RequiredSwitch';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';
import MultiSwitch from './MultiSwitch';
import * as DisplayStrings from '../../../../../displayStrings';

const SystemOnlyQLookupConfiguration = ({ fieldIndex, fieldLabel }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper>
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <MultiSwitch control={control} fieldIndex={fieldIndex} isDisabled={true} />
      <RequiredSwitch
        control={control}
        fieldIndex={fieldIndex}
        isDisabled={true}
        tooltip={DisplayStrings.DisableRequiredTooltip(fieldLabel)}
      />
    </FieldConfigurationWrapper>
  );
};

export default SystemOnlyQLookupConfiguration;
